import { ReactNode } from 'react';



const PaymentStep = ({ step, title, description, icon, isLast = false }) => {
  return (
    <div className="relative">
      <div className="flex items-start space-x-6">
        {/* Step Number & Icon */}
        <div className="flex flex-col items-center">
          <div className="bg-[#0048AE] text-white rounded-full w-14 h-14 flex items-center justify-center font-bold text-lg shadow-lg">
            {step}
          </div>
          {!isLast && (
            <div className="w-0.5 h-20 bg-gradient-to-b from-blue-500 to-purple-600 mt-4 opacity-50"></div>
          )}
        </div>

        {/* Content */}
        <div className="flex-1 pb-8">
          <div className="bg-[#050B20] rounded-xl p-6 shadow-lg border  transition-all duration-300">
            <div className="flex items-center space-x-3 mb-3">
              <div className="text-blue-400 text-2xl">
                {icon}
              </div>
              <h3 className="text-l font-bold text-white">{title}</h3>
            </div>
            <p className="text-gray-300 leading-relaxed">{description}</p>
          </div>
        </div>
       
      </div>
    </div>
  );
}
export default PaymentStep;